"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FortnoxIntegrationLogEntityType = exports.IntegrationLogDirection = exports.IntegrationLogEntityType = exports.IntegrationLogTryResultType = exports.IntegrationLogStatus = exports.IntegrationModeType = exports.WebhookUrlTypes = exports.IntegrationCategory = exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["Test"] = -1] = "Test";
    IntegrationType[IntegrationType["Caspeco"] = 0] = "Caspeco";
    IntegrationType[IntegrationType["Planday"] = 1] = "Planday";
    IntegrationType[IntegrationType["PublicApi"] = 2] = "PublicApi";
    IntegrationType[IntegrationType["Fortnox"] = 3] = "Fortnox";
    IntegrationType[IntegrationType["Personalkollen"] = 4] = "Personalkollen";
    IntegrationType[IntegrationType["Mews"] = 5] = "Mews";
    IntegrationType[IntegrationType["AdyenSettlementReport"] = 6] = "AdyenSettlementReport";
    IntegrationType[IntegrationType["Deliverect"] = 7] = "Deliverect";
    IntegrationType[IntegrationType["EmailZReport"] = 8] = "EmailZReport";
    IntegrationType[IntegrationType["Retain24"] = 9] = "Retain24";
    IntegrationType[IntegrationType["MPSGiftCards"] = 10] = "MPSGiftCards";
    IntegrationType[IntegrationType["Nets"] = 11] = "Nets";
    IntegrationType[IntegrationType["Raindance"] = 12] = "Raindance";
    IntegrationType[IntegrationType["Como"] = 13] = "Como";
    IntegrationType[IntegrationType["Stammy"] = 14] = "Stammy";
    IntegrationType[IntegrationType["Omniboost"] = 15] = "Omniboost";
    IntegrationType[IntegrationType["Maitres"] = 16] = "Maitres";
    IntegrationType[IntegrationType["Adyen"] = 17] = "Adyen";
    IntegrationType[IntegrationType["Surfboard"] = 18] = "Surfboard";
    IntegrationType[IntegrationType["Wolt"] = 19] = "Wolt";
    IntegrationType[IntegrationType["PenguinLockers"] = 20] = "PenguinLockers";
    IntegrationType[IntegrationType["Icoupon"] = 21] = "Icoupon";
    IntegrationType[IntegrationType["EANSupport"] = 22] = "EANSupport";
    IntegrationType[IntegrationType["PayAndGo"] = 23] = "PayAndGo";
    IntegrationType[IntegrationType["AirportLoungeReport"] = 24] = "AirportLoungeReport";
    IntegrationType[IntegrationType["TableReservation"] = 25] = "TableReservation";
    IntegrationType[IntegrationType["Kwick"] = 26] = "Kwick";
    IntegrationType[IntegrationType["TapToPay"] = 27] = "TapToPay";
    IntegrationType[IntegrationType["MultiCurrency"] = 28] = "MultiCurrency";
    IntegrationType[IntegrationType["GiftCards"] = 29] = "GiftCards";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
var IntegrationCategory;
(function (IntegrationCategory) {
    IntegrationCategory[IntegrationCategory["None"] = 0] = "None";
    IntegrationCategory[IntegrationCategory["SalesExport"] = 1] = "SalesExport";
    IntegrationCategory[IntegrationCategory["Invoicing"] = 2] = "Invoicing";
    IntegrationCategory[IntegrationCategory["Accounting"] = 4] = "Accounting";
    IntegrationCategory[IntegrationCategory["LabourImport"] = 8] = "LabourImport";
    IntegrationCategory[IntegrationCategory["Reporting"] = 16] = "Reporting";
    IntegrationCategory[IntegrationCategory["Channel"] = 32] = "Channel";
    IntegrationCategory[IntegrationCategory["PaymentTerminal"] = 64] = "PaymentTerminal";
    IntegrationCategory[IntegrationCategory["PMS"] = 128] = "PMS";
})(IntegrationCategory = exports.IntegrationCategory || (exports.IntegrationCategory = {}));
// Public Api
var WebhookUrlTypes;
(function (WebhookUrlTypes) {
    WebhookUrlTypes[WebhookUrlTypes["Unknown"] = 0] = "Unknown";
    WebhookUrlTypes[WebhookUrlTypes["OrderCreated"] = 1] = "OrderCreated";
    WebhookUrlTypes[WebhookUrlTypes["OrderRefunded"] = 2] = "OrderRefunded";
    WebhookUrlTypes[WebhookUrlTypes["ProductCreated"] = 3] = "ProductCreated";
    WebhookUrlTypes[WebhookUrlTypes["ProductDeleted"] = 4] = "ProductDeleted";
    WebhookUrlTypes[WebhookUrlTypes["ProductUpdated"] = 5] = "ProductUpdated";
    WebhookUrlTypes[WebhookUrlTypes["VoucherBasisPublished"] = 6] = "VoucherBasisPublished";
    WebhookUrlTypes[WebhookUrlTypes["TicketStatusUpdated"] = 7] = "TicketStatusUpdated";
    WebhookUrlTypes[WebhookUrlTypes["CustomerAddedToOutlet"] = 8] = "CustomerAddedToOutlet";
    WebhookUrlTypes[WebhookUrlTypes["SendInvoices"] = 9] = "SendInvoices";
})(WebhookUrlTypes = exports.WebhookUrlTypes || (exports.WebhookUrlTypes = {}));
var IntegrationModeType;
(function (IntegrationModeType) {
    IntegrationModeType[IntegrationModeType["Integration"] = 0] = "Integration";
    IntegrationModeType[IntegrationModeType["Addon"] = 1] = "Addon";
})(IntegrationModeType = exports.IntegrationModeType || (exports.IntegrationModeType = {}));
// Overall status of the integration log retries
var IntegrationLogStatus;
(function (IntegrationLogStatus) {
    IntegrationLogStatus[IntegrationLogStatus["InProgress"] = 0] = "InProgress";
    IntegrationLogStatus[IntegrationLogStatus["Successful"] = 1] = "Successful";
    IntegrationLogStatus[IntegrationLogStatus["Failed"] = 2] = "Failed";
})(IntegrationLogStatus = exports.IntegrationLogStatus || (exports.IntegrationLogStatus = {}));
// Status of integration log retry
var IntegrationLogTryResultType;
(function (IntegrationLogTryResultType) {
    IntegrationLogTryResultType[IntegrationLogTryResultType["Unknown"] = -1] = "Unknown";
    IntegrationLogTryResultType[IntegrationLogTryResultType["Successful"] = 0] = "Successful";
    IntegrationLogTryResultType[IntegrationLogTryResultType["BadRequest"] = 1] = "BadRequest";
    IntegrationLogTryResultType[IntegrationLogTryResultType["InternalException"] = 2] = "InternalException";
    IntegrationLogTryResultType[IntegrationLogTryResultType["IntegrationException"] = 3] = "IntegrationException";
    IntegrationLogTryResultType[IntegrationLogTryResultType["Timeout"] = 4] = "Timeout";
    IntegrationLogTryResultType[IntegrationLogTryResultType["Forbidden"] = 5] = "Forbidden";
    IntegrationLogTryResultType[IntegrationLogTryResultType["NotFound"] = 6] = "NotFound";
    IntegrationLogTryResultType[IntegrationLogTryResultType["Canceled"] = 7] = "Canceled";
})(IntegrationLogTryResultType = exports.IntegrationLogTryResultType || (exports.IntegrationLogTryResultType = {}));
var IntegrationLogEntityType;
(function (IntegrationLogEntityType) {
    IntegrationLogEntityType[IntegrationLogEntityType["None"] = 0] = "None";
    IntegrationLogEntityType[IntegrationLogEntityType["Company"] = 1] = "Company";
    IntegrationLogEntityType[IntegrationLogEntityType["Customer"] = 2] = "Customer";
    IntegrationLogEntityType[IntegrationLogEntityType["Invoice"] = 3] = "Invoice";
    IntegrationLogEntityType[IntegrationLogEntityType["ZReport"] = 4] = "ZReport";
    IntegrationLogEntityType[IntegrationLogEntityType["Payment"] = 5] = "Payment";
    IntegrationLogEntityType[IntegrationLogEntityType["LabourCost"] = 6] = "LabourCost";
    IntegrationLogEntityType[IntegrationLogEntityType["Order"] = 7] = "Order";
    IntegrationLogEntityType[IntegrationLogEntityType["SettlementReport"] = 8] = "SettlementReport";
    IntegrationLogEntityType[IntegrationLogEntityType["Product"] = 9] = "Product";
    IntegrationLogEntityType[IntegrationLogEntityType["ScheduledJob"] = 10] = "ScheduledJob";
    IntegrationLogEntityType[IntegrationLogEntityType["InvoiceTip"] = 11] = "InvoiceTip";
    IntegrationLogEntityType[IntegrationLogEntityType["AdyenFeeReport"] = 12] = "AdyenFeeReport";
    IntegrationLogEntityType[IntegrationLogEntityType["RaindanceReport"] = 13] = "RaindanceReport";
})(IntegrationLogEntityType = exports.IntegrationLogEntityType || (exports.IntegrationLogEntityType = {}));
var IntegrationLogDirection;
(function (IntegrationLogDirection) {
    IntegrationLogDirection[IntegrationLogDirection["Unknown"] = 0] = "Unknown";
    IntegrationLogDirection[IntegrationLogDirection["Export"] = 1] = "Export";
    IntegrationLogDirection[IntegrationLogDirection["Import"] = 2] = "Import";
})(IntegrationLogDirection = exports.IntegrationLogDirection || (exports.IntegrationLogDirection = {}));
var FortnoxIntegrationLogEntityType;
(function (FortnoxIntegrationLogEntityType) {
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["None"] = 0] = "None";
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["Invoice"] = 1] = "Invoice";
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["ZReport"] = 2] = "ZReport";
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["Company"] = 3] = "Company";
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["InvoiceTip"] = 4] = "InvoiceTip";
    FortnoxIntegrationLogEntityType[FortnoxIntegrationLogEntityType["AdyenFeeReport"] = 5] = "AdyenFeeReport";
})(FortnoxIntegrationLogEntityType = exports.FortnoxIntegrationLogEntityType || (exports.FortnoxIntegrationLogEntityType = {}));
